import { gql } from '@/__generated__';

export const DISABLE_DEVICE_ALERTS = gql(`#graphql
  mutation DisableDeviceAlertsModal($deviceId: ID!) {
    disableAlertConfiguration(input: { deviceId: $deviceId }) {
      id
      rawData
      activeConfigurations {
        id
      }
      basicConfigurations {
        id
        flow {
          id
        }
        level {
          id
        }
        lastFlow {
          id
        }
        lastLevel {
          id
        }
      }
    }
  }
`);
